import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchVerticalTLProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchVerticalTL: FC<SrWidgetMatchVerticalTLProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true, disableMatchHeader: true };
    return <SrWidget widgetName="match.verticalTimeline" widgetProps={widgetProps} {...props} />;
};
